module.exports = __webpack_public_path__ + "static/press-kit-banner-6dca5e5a2c0b8b9fd1cf9f7e6ffabf91.png";